// Spec 27 PR 2a — entrance choreography primitive.
//
// Same shape as the Ask canvas Stagger (apps/web/src/components/
// canvas/widgets.tsx) but separate so gen-ui doesn't depend on
// the Ask canvas tree. Reuses the `canvas-in` keyframe declared
// in index.css.

import type { ReactNode } from "react";

interface GenStaggerProps {
	index: number;
	children: ReactNode;
	/** Override the base delay step (default 70ms). Used by widgets
	 *  that want a longer beat between sub-element entrances. */
	stepMs?: number;
}

export function GenStagger({ index, children, stepMs = 70 }: GenStaggerProps) {
	return (
		<div
			style={{
				opacity: 0,
				transform: "translateY(4px)",
				animation: "canvas-in 280ms ease-out forwards",
				animationDelay: `${index * stepMs}ms`,
			}}
		>
			{children}
		</div>
	);
}
